export const selectTranslationKeys = {
  selectClear: 'select.clear',
  selectSelectAll: 'select.select-all',
  selectSelected: 'select.selected',
  selectPlaceholder: 'select.placeholder',
  selectAll: 'select.all',
  selectNotSelected: 'select.not-selected',
}
